// project imports
import { processDateFieldInput, processDateFieldOutput, processTimeFieldInput, processTimeFieldOutput } from 'utils/processors';
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    sendAt: 'sendAt' in (values || {}) ? processDateFieldInput(values.sendAt) : null,
    sendTime: 'sendTime' in (values || {}) ? processTimeFieldInput(values.sendTime) : null,
    startsAt: 'startsAt' in (values || {}) ? processDateFieldInput(values.startsAt) : null,
    endsAt: 'endsAt' in (values || {}) ? processDateFieldInput(values.endsAt) : null,
    nextSendAt: 'nextSendAt' in (values || {}) ? processDateFieldInput(values.nextSendAt) : null,
    lastSentAt: 'lastSentAt' in (values || {}) ? processDateFieldInput(values.lastSentAt) : null
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    id: undefined,
    sendAt: 'sendAt' in (values || {}) ? processDateFieldOutput(values.sendAt, 'yyyy-MM-dd HH:mm') : undefined,
    sendTime: 'sendTime' in (values || {}) ? processTimeFieldOutput(values.sendTime) : undefined,
    startsAt: 'startsAt' in (values || {}) ? processDateFieldOutput(values.startsAt, 'yyyy-MM-dd HH:mm') : undefined,
    endsAt: 'endsAt' in (values || {}) ? processDateFieldOutput(values.endsAt, 'yyyy-MM-dd HH:mm') : undefined,
    nextSendAt: undefined,
    lastSentAt: undefined
});
